import * as React from 'react'
import { Button, Modal, Typography } from 'antd'
import { ClockCircleOutlined } from '@ant-design/icons'
import { AuthContext } from 'Store'
import { useIdleSession, IDLE_TIMEOUT_MS } from 'Services'

const { Paragraph, Text } = Typography

const formatCountdown = (total_seconds: number): string => {
    const minutes = Math.floor(total_seconds / 60)
    const seconds = total_seconds % 60
    return `${minutes}:${String(seconds).padStart(2, '0')}`
}

// RPD-5169: arms the 15-minute idle watcher while a user is signed in and
// renders the 12-minute warning. On timeout the idle hook flags
// sessionStorage and we sign out — the Hub 'signOut' event clears the user
// and PrivateRoute redirects to /login, which shows the expiry message.
const SessionTimeoutManagerComponent: React.FC = () => {
    const { useCallback, useContext } = React
    const { user, signOut } = useContext(AuthContext)

    const onTimeout = useCallback(() => {
        signOut()
    }, [signOut])

    const { is_warning, seconds_left, staySignedIn } = useIdleSession(
        !!user,
        onTimeout
    )

    return (
        <Modal
            visible={is_warning}
            closable={false}
            maskClosable={false}
            keyboard={false}
            title={
                <>
                    <ClockCircleOutlined /> Are you still there?
                </>
            }
            footer={
                <Button type="primary" onClick={staySignedIn}>
                    Stay signed in
                </Button>
            }
        >
            <Paragraph>
                You have been inactive for a while. For security, you will be
                signed out automatically after{' '}
                {Math.round(IDLE_TIMEOUT_MS / 60000)} minutes of inactivity.
            </Paragraph>
            <Paragraph>
                Signing out in{' '}
                <Text strong>{formatCountdown(seconds_left)}</Text>
            </Paragraph>
        </Modal>
    )
}

export default SessionTimeoutManagerComponent
